import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity } from '../../../../services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-label',
  templateUrl : './label.component.html',
  styleUrls: ['./label.component.css']
})
export class LabelComponent implements OnInit {

  @Input() nodo: NodoEntity;

  value: string;
  description: string;

  constructor() { }

  ngOnInit() {
    if (this.nodo) {
      // console.log('*** LABEL', this.nodo);
      this.value = this.nodo.titulo;
      this.description = this.nodo.descripcion;
    } else {
      this.value = '';
    }
  }

}
